const actionTypeIdentifier = '70C7688D-9685-4B18-BF9B-B8DD1195FE84';

export const getInventoryEquipment = `GET-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const setInventoryEquipmentError = `SET-INVENTORY-EQUIPMENT-ERROR-${actionTypeIdentifier}`;
export const setInventoryEquipmentColSearchStr = `SET-INVENTORY-EQUIPMENT-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortInventoryEquipmentItems = `SORT-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const setInventoryEquipmentPageSize = `SET-INVENTORY-EQUIPMENT-PAGESIZE-${actionTypeIdentifier}`;
export const setInventoryEquipmentFilter = `SET-INVENTORY-EQUIPMENT-FILTER-${actionTypeIdentifier}`;
export const applyInventoryEquipmentFilter = `APPLY-INVENTORY-EQUIPMENT-FILTER-${actionTypeIdentifier}`;
export const getInventoryEquipmentDetailsById = `GET-INVENTORY-EQUIPMENT-DETAILS-${actionTypeIdentifier}`;
export const getInventoryEquipmentComments = `GET-INVENTORY-EQUIPMENT-COMMENTS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-INVENTORY-EQUIPMENT-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const getEquipmentdropDownList = `GET-INVENTORY-EQUIPMENT-DROPDOWN-${actionTypeIdentifier}`;
export const setDefaultInventoryEquipment = `SET-DEFAULT-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const resetInventoryEquipmentData = `RESET-INVENTORY-EQUIPMENT-DATA-${actionTypeIdentifier}`;

export const inventoryEquipmentModel = {
    inventoryEquipmentDetails: {
        equipmentId : 0,
        equipmentTypeId: 0,
        model : "",
        productName : "",
        equipmentStatusId : 0,
        vendorId : 0,
        currency : "",
        circuitTypeId: 0,
        contractId : 0,
        orderCost : null,
        discountedOrderCost : null,
        mrc : null,
        nrc : null,
        glCodeId : 0,
        costCodeId: 0,
        companyCodeId : 0,
        vipId : 0,
    }
}